import React from "react";
import cns from "classnames";
import { useObserver } from "mobx-react";
import { Grid, Divider } from "@material-ui/core";
import locale from "@bonliva-crm/locale";
import { Text, Select } from "@components/formx";
import { useConsultantEditorContext } from "../ConsultantEditorContext";
import { ConsultantEditorStore } from "../ConsultantEditorStore";
import { makeStyles } from "@material-ui/core/styles";
import { ThemeType } from "@theme";
import { Option } from "@components/Select";

export function AddressInfo() {
  const editorStore: ConsultantEditorStore = useConsultantEditorContext();
  const classes = useStyles({});

  const countriesOptions: Option[] = editorStore.allCountriesWorldwide
    .filter((c) => c.onTopInSearch)
    .sortBy((c) => c.sort)
    .toLabelValue(
      (c) => locale.getCountryName(c.name),
      (c) => c.name
    );

  countriesOptions.push({
    label: <Divider />,
    value: "div1",
    disabled: true
  });

  countriesOptions.push(
    ...editorStore.allCountriesWorldwide
      .filter((c) => !c.onTopInSearch)
      .sort((a, b) => (a.name < b.name ? -1 : 1))
      .map((c) => ({
        label: locale.getCountryName(c.name),
        value: c.name
      }))
  );

  return useObserver(() => {
    return (
      <Grid container spacing={1}>
        <Grid item xs={12} sm={6}>
          <div
            className={cns({
              [classes.notApproved]:
                editorStore.consultantCVManager.keyNotApproved("address.country")
            })}
          >
            <Select
              name="address.country"
              label={locale.Country}
              options={countriesOptions}
            />
          </div>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Text
            name="address.zipCode"
            label={locale["ZIP code"]}
            TextFieldProps={{
              fullWidth: true,
              className: cns({
                [classes.notApproved]:
                  editorStore.consultantCVManager.keyNotApproved("address.zipCode")
              })
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Text
            name="address.city"
            label={locale.City}
            TextFieldProps={{
              fullWidth: true,
              className: cns({
                [classes.notApproved]:
                  editorStore.consultantCVManager.keyNotApproved("address.city")
              })
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Text
            name="address.streetName"
            label={locale["Street address"]}
            TextFieldProps={{
              fullWidth: true,
              className: cns({
                [classes.notApproved]:
                  editorStore.consultantCVManager.keyNotApproved("address.streetName")
              })
            }}
          />
        </Grid>
      </Grid>
    );
  });
}

const useStyles = makeStyles((theme: ThemeType) => ({
  notApproved: {
    ...theme.palette.error
  }
}));
